import React from 'react';
import UserResearchBanner from '../components/user-research-banner';

// A banner to be rendered in the top-right corner of a content page
// eslint-disable-next-line react/display-name
export default () => {
  return <UserResearchBanner />;
};
